import React, { useState } from "react";
import { downloadBlob } from "../utils/downloadBlob";

const fmt = (d) => (d ? new Date(d).toLocaleString() : "—");

// Org-wide supporting evidence register (prototype "Evidence register"): notes, HTTPS links and
// scanned attachments tied to policy versions across every live policy.
const PolicyEvidenceRegister = ({ items, apiCall, onOpenPolicy }) => {
    const [error, setError] = useState(null);

    const download = async (item) => {
        try {
            const blob = await apiCall("GET", `/security-insights/policy-docs/${item.policyId}/evidence/${item.id}/download`, null, false, "blob");
            downloadBlob(blob, item.fileName);
        } catch { setError("Download failed."); }
    };

    if (!items) return <p className="text-xs text-gray-400">Loading evidence…</p>;
    return (
        <div className="space-y-2">
            <div className="text-xs text-gray-500 bg-white border border-gray-200 rounded-lg px-3 py-2">Notes, HTTPS links and malware-scanned attachments are tied to policy versions and retained for audit (soft-deleted only).</div>
            {error && <div className="text-xs text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</div>}
            {items.length === 0 && <p className="text-xs text-gray-400">No supporting evidence yet. Open a policy to add a note, link or attachment.</p>}
            {items.length > 0 && (
                <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full text-xs">
                            <thead><tr className="text-left text-gray-400 uppercase tracking-wide border-b border-gray-200">
                                <th className="px-3 py-2">Policy</th><th className="px-3 py-2">Evidence</th><th className="px-3 py-2">Version</th><th className="px-3 py-2">Added by</th><th className="px-3 py-2">Added</th><th className="px-3 py-2"></th>
                            </tr></thead>
                            <tbody>
                                {items.map(item => (
                                    <tr key={item.id} className="border-b border-gray-100">
                                        <td className="px-3 py-2"><button onClick={() => onOpenPolicy?.(item.policyId, "evidence")} className="text-indigo-700 font-medium hover:underline text-left">{item.policyTitle}</button></td>
                                        <td className="px-3 py-2">
                                            <div className="text-gray-800">{item.title || item.fileName} <span className="px-1.5 py-0.5 rounded-full text-[10px] border bg-gray-100 text-gray-600 border-gray-200">{item.kind}</span></div>
                                            {item.kind === "Link" && <a href={item.value} target="_blank" rel="noopener noreferrer" className="text-indigo-700 underline break-all">{item.value}</a>}
                                            {item.kind === "Note" && <div className="text-gray-500">{item.value}</div>}
                                            {item.description && <div className="text-gray-400">{item.description}</div>}
                                            {item.sha256 && <div className="text-gray-400 font-mono" title={item.sha256}>sha256 {item.sha256.slice(0, 16)}…</div>}
                                        </td>
                                        <td className="px-3 py-2 text-gray-600">v{item.policyVersion ?? "—"}</td>
                                        <td className="px-3 py-2 text-gray-600">{item.uploadedByName || "—"}</td>
                                        <td className="px-3 py-2 text-gray-600">{fmt(item.uploadedAt)}</td>
                                        <td className="px-3 py-2">{item.kind === "Attachment" && <button onClick={() => download(item)} className="text-indigo-700 bg-indigo-50 border border-indigo-200 rounded px-2 py-0.5">Download</button>}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PolicyEvidenceRegister;
